import Footer from "../../components/Footer";
import {Box} from "@mui/material";
import Main from "./Main";
import {Outlet} from "react-router-dom";
import ScrollToTop from "../../components/ScrollToTop";
import CookieConsent from "../../pages/CookieConsent";

export default function Dashboard() {

    return (
        <>
            <Box
                sx={{
                    display: {lg: "flex"},
                    minHeight: {lg: 1}
                }}>
                <Main>
                    <CookieConsent/>
                    <ScrollToTop/>
                    <Outlet/>
                    <Footer/>
                </Main>
            </Box>
        </>
    )
}
